import {Injectable} from '@angular/core'

@Injectable()

export class TutorialesService {


  //jz-T5BcZLkg video horizontal
  tabla = 'rest_tutos_0001';
  data = [
    {id: 1, tipo: 2,  name: 'Como hacer traspasos de mercancias entre locales', description: '', url: 'hz8p-CrMtck', thum: 'https://i.ytimg.com/vi/hz8p-CrMtck/hqdefault.jpg', visto: 0},
    {id: 2, tipo: 2, name: 'Como hacer un inventario del almacen principal', description: '', url: 'EZ9tpuuRKk0', thum: 'https://i.ytimg.com/vi/EZ9tpuuRKk0/hqdefault.jpg', visto: 0},
    {id: 3, tipo: 2, name: 'Como hacer una recarga de camaras', description: '', url: 'THJiNmazRmk', thum: 'https://i.ytimg.com/vi/Bt5dynZv00Q/hqdefault.jpg', visto: 0},
    {id: 4, tipo: 2, name: 'Como hacer un inventario en recargas', description: '', url: 'na9rB82xr8g', thum: 'https://i.ytimg.com/vi/na9rB82xr8g/hqdefault.jpg', visto: 0},
    {id: 5, tipo: 1, name: 'Primeros pasos tareas', description: '', url: 'U-HMo4_rqiE', thum: 'https://i.ytimg.com/vi/U-HMo4_rqiE/hqdefault.jpg', visto: 0},
    {id: 6, tipo: 1, name: 'Crear incidencia en checklist', description: '', url: 'wLe5zjwCLrE', thum: 'https://i.ytimg.com/vi/wLe5zjwCLrE/hqdefault.jpg', visto: 0},
    {id: 7, tipo: 3, name: 'Añadir producto a proveedor', description: '', url: 'FnFab8CiPx8', thum: 'https://i.ytimg.com/vi/FnFab8CiPx8/hqdefault.jpg', visto: 0},
    {id: 8, tipo: 3, name: 'Crear nuevo proveedor', description: '', url: 'nC5rByAdb0Y', thum: 'https://i.ytimg.com/vi/nC5rByAdb0Y/hqdefault.jpg', visto: 0},
    {id: 9, tipo: 3, name: 'Como crear un producto', description: '', url: 'BT1ejLY8b_U', thum: 'https://i.ytimg.com/vi/BT1ejLY8b_U/hqdefault.jpg', visto: 0},
    {id: 10, tipo: 3, name: 'Como recibir un pedido', description: '', url: '4Co7aePjdWo', thum: 'https://i.ytimg.com/vi/4Co7aePjdWo/hqdefault.jpg', visto: 0},
    {id: 11, tipo: 3, name: 'Como crear un pedido desde la app', description: '', url: 'AZxUD6GnfdQ', thum: 'https://i.ytimg.com/vi/AZxUD6GnfdQ/hqdefault.jpg', visto: 0},
    {id: 12, tipo: 3, name: 'Como crear un Albaran', description: '', url: 'PBJQ2Mqxf0M', thum: 'https://i.ytimg.com/vi/PBJQ2Mqxf0M/hqdefault.jpg', visto: 0},
    {id: 16, tipo: 3, name: 'Como crear un Abono', description: '', url: 'Bt5dynZv00Q', thum: 'https://i.ytimg.com/vi/Bt5dynZv00Q/hqdefault.jpg', visto: 0},
    {id: 13, tipo: 4, name: 'Recetas. Primeros pasos.', description: '', url: 'ThGgpGsMpgk', thum: 'https://i.ytimg.com/vi/ThGgpGsMpgk/hqdefault.jpg', visto: 0},
    {id: 14, tipo: 4, name: 'Como funciona la mise en place', description: '', url: 'XsCSRkArEGU', thum: 'https://i.ytimg.com/vi/XsCSRkArEGU/hqdefault.jpg', visto: 0},
    {id: 15, tipo: 4, name: 'Primeros pasos escandallos', description: '', url: 'Ik5RtW7Fw7s', thum: 'https://i.ytimg.com/vi/Ik5RtW7Fw7s/hqdefault.jpg', visto: 0},
    {id: 17, tipo: 9, name: 'Herramienta Compras -- Yurest Solutions', description: '', url: 'RNTLMxiw07w', thum: 'https://i.ytimg.com/vi/RNTLMxiw07w/hqdefault.jpg', visto: 0}
  ];

  constructor() {

    this.data = JSON.parse(localStorage.getItem(this.tabla)) || this.set(this.data);
  }


  /**
   * Devuelve la coeccion de datos
   *
   */
  get() {

    return this.data;

  }



  /**
   * Deveulve un objeto por su ID
   *
   */
  getById(id){

    let aux = null;

    for(let item of this.data){

      if(item.id == id){

        aux = item;
        break;
      }
    }

    return aux;
  }



  /**
   * Guarda la coleccion de datos
   *
   */
  set(data) {

    this.data = data;
    localStorage.setItem(this.tabla, JSON.stringify(data));

    return this.data;

  }



  /**
   * Marca un video como visto y guarda
   *
   */
  setVisto(id, visto = 1){

    for(let item of this.data){

      if(item.id == id){

        item.visto = visto;
        break;
      }
    }

    this.set(this.data);
  }
}



// WEBPACK FOOTER //
// ./src/services/TutorialesService.ts